module.exports = __webpack_public_path__ + "a7c71cb5d1b65d4925116b8cb49e52df.jpg";